/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChangeEmailRequest
 */
export interface ChangeEmailRequest {
  /**
   *
   * @type {string}
   * @memberof ChangeEmailRequest
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ChangeEmailRequest
   */
  password?: string | null;
}

export function ChangeEmailRequestFromJSON(json: any): ChangeEmailRequest {
  return ChangeEmailRequestFromJSONTyped(json, false);
}

export function ChangeEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeEmailRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, "id") ? undefined : json["id"],
    password: !exists(json, "password") ? undefined : json["password"],
  };
}

export function ChangeEmailRequestToJSON(value?: ChangeEmailRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    password: value.password,
  };
}
